/* eslint-disable max-classes-per-file */
/* eslint-disable no-this-before-super */
/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import "phaser";
import { Entity } from './Entity'
import { loadAudio, loadImage } from "./../modules/utiltes"
import { setSwitcher, getSwitcher } from './../modules/storage'
import { SoundManager } from "../ScenesHelpers/SoundManager";
export class ShootFactor {
    create = (
        scene,
        x,
        y,
        key,
        type,
        level,
        scaleX,
        scaleY,
        animekey,
        speedX,
        speedY,
        audio,
        player,
        shootClass) => {
        switch (shootClass) {
            case Shoot:
                return new Shoot(scene, x, y, key, type, level, scaleX, scaleY, animekey, speedX, speedY, audio, player)
            case ShootZig:
                return new ShootZig(scene, x, y, key, type, level, scaleX, scaleY, animekey, speedX, speedY, audio, player)
            case ShootPlasma:
                return new ShootPlasma(scene, x, y, key, type, level, scaleX, scaleY, animekey, speedX, speedY, audio, player)
            case ShootRotate:
                return new ShootRotate(scene, x, y, key, type, level, scaleX, scaleY, animekey, speedX, speedY, audio, player)
            case ShootRocket:
                return new ShootRocket(scene, x, y, key, type, level, scaleX, scaleY, animekey, speedX, speedY, audio, player)
        }
    }
}
export class Shoot extends Entity {
    /** 
     * Shoot constructor @param {object} scene -scene that Shoot object belongs to- @param {number} x - value of Shoot on x axis - @param {number} y - value of Shoot on y axis - @param {String} key -contains key of Shoot- @param {String} type -type of Shoot - @param {number} level -level of Shoot- @param {number} scalex -scale Shoot in x axis- @param {number} scaley -scale Shoot in y axis- @param {string}audio -contains key of audio-@param {string} animekey -contains key of animation-
     * loadAssets function : load asset on screen and it takes @param {object} scene -scene that Shoot object belongs to-  @param {String} key -key of Shoot asset-  @param {String} keyLink -path of asset location-@param {String} audio -contains key of Shoot audio- @param {String} audioLink -contains path of Shoot audio-
     * */
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        scaleX,
        scaleY,
        animekey,
        speedX,
        speedY,
        audio,
        player
    ) {
        const setTimeOutValue = 1900
        super(scene, x, y, key, type);
        this.scene = scene
        this.x = x
        this.y = y
        this.key = key
        this.type = type
        this.level = level
        this.scaleX = scaleX
        this.scaleY = scaleY
        this.animekey = animekey
        this.speedX = speedX
        this.speedY = speedY
        this.audio = audio
        this.player = player
        this.body.velocity.x = speedX;
        this.body.velocity.y = speedY;
        this.setData("shootkey", this.key);
        this.setData("shootlevel", this.level);
        if (this.animekey != null) {
            setTimeout(() => {
                super.setTexture(this.animekey);
                super.play(this.animekey);
            }, setTimeOutValue);
        }
    }
    static loadAssets(scene, key, audio, keylink, audiolink) {
        loadImage(scene, `${key}`, `${keylink}`)
        loadAudio(scene, `${audio}`, `${audiolink}`)
    }
    applyShootAction() {}
}
export class ShootRocket extends Shoot {
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        scaleX,
        scaleY,
        animekey,
        speedX,
        speedY,
        audio,
        player
    ) {
        super(
            scene,
            x,
            y,
            key,
            type,
            level,
            scaleX,
            scaleY,
            animekey,
            speedX,
            speedY,
            audio,
            player
        );
    }

    applyShootAction() {
        const setTimeOutValue = 1900
        setTimeout(() => {
            const OPTIONS = {
                BOSS: {
                    "COUNTER": "bosscounter"
                },
                ENEMY: {
                    "LEVEL": "enemylevel",
                    "KEY": "enemykey"
                },
            }
            if(this.scene.enemies!=undefined){
                for (let i = 0; i < this.scene.enemies.getChildren().length; i++) {
                const enemy = this.scene.enemies.getChildren()[i];
                if (enemy.getData(OPTIONS.ENEMY.KEY) == "boss") {
                    enemy.setData(OPTIONS.BOSS.COUNTER, enemy.getData(OPTIONS.BOSS.COUNTER) + 5)
                    if (enemy.getData(OPTIONS.BOSS.COUNTER) >= 10 * enemy.getData(OPTIONS.ENEMY.LEVEL)) {
                        enemy.explode();
                    }
                } else {
                    enemy.explode();
                }
                this.player.setCurrentPlayerScore(this.player.getCurrentPlayerScore() + 1);
                if (this.player.getCurrentPlayerScore() > parseInt(this.player.getPlayerHighScore(), 10)) {
                    this.player.setPlayerHighScore(this.player.getCurrentPlayerScore());
                }

                this.sfx.rocketexplode.play();
                this.explode();
            }
            }


        }, setTimeOutValue);
    }
}
export class ShootRotate extends Shoot {
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        scaleX,
        scaleY,
        animekey,
        speedX,
        speedY,
        audio,
        player
    ) {
        super(
            scene,
            x,
            y,
            key,
            type,
            level,
            scaleX,
            scaleY,
            animekey,
            speedX,
            speedY,
            audio,
            player
        );
    }
    applyShootAction() {
        const setIntervalValue = 16
        setInterval(() => {
            let period = this.scene.time.now * 0.002;
            let radius = 100;
            if (this.body != null) {
                this.body.velocity.x = Math.cos(period) * radius;
                this.body.velocity.y = -50 + Math.sin(period) * radius;
            }
        }, setIntervalValue);
    }
}
export class ShootPlasma extends Shoot {
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        scaleX,
        scaleY,
        animekey,
        speedX,
        speedY,
        audio,
        player
    ) {
        super(
            scene,
            x,
            y,
            key,
            type,
            level,
            scaleX,
            scaleY,
            animekey,
            speedX,
            speedY,
            audio,
            player
        );
    }
    applyShootAction() {
        const setIntervalValue = 1
        setInterval(() => {
            if (this.body != null) {
                this.scaleX = this.scaleX + 0.01
                this.scaleY = this.scaleY + 0.01
            }
        }, setIntervalValue);
    }
}
export class ShootZig extends Shoot {
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        scaleX,
        scaleY,
        animekey,
        speedX,
        speedY,
        audio,
        player
    ) {
        super(
            scene,
            x,
            y,
            key,
            type,
            level,
            scaleX,
            scaleY,
            animekey,
            speedX,
            speedY,
            audio,
            player
        );
    }
    applyShootAction() {
        if (getSwitcher()) {
            this.body.velocity.x = -1 * this.speedX;
            setSwitcher(false)
        } else {
            this.body.velocity.x = 1 * this.speedX;
            setSwitcher(true)
        }
    }
}